import { render, staticRenderFns } from "./GlobalPopup.vue?vue&type=template&id=00c8c97e&"
import script from "./GlobalPopup.vue?vue&type=script&lang=js&"
export * from "./GlobalPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports